import { Plural, useLingui } from '@lingui/react/macro';

import Hide from '@rover/icons/svg/hide.svg';
import Show from '@rover/icons/svg/show.svg';
import { Button, Flex, Text } from '@rover/kibble/core';

import { GALLERY_CONTAINER_WIDTH } from './constants';
import StickyGalleryToolbar from './StickyGalleryToolbar';

type Props = {
  selectedCount: number;
  isSaving: boolean;
  contrast?: boolean;
  onMakePrivate: () => void;
  onMakePublic: () => void;
};

const GallerySelectionBar = ({
  selectedCount,
  isSaving,
  contrast = false,
  onMakePrivate,
  onMakePublic,
}: Props): JSX.Element => {
  const { t } = useLingui();

  return (
    <StickyGalleryToolbar contrast={contrast}>
      <Flex
        flexDirection="row"
        width="100%"
        maxWidth={GALLERY_CONTAINER_WIDTH}
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        gap="3x"
        sx={{ marginLeft: 'auto', marginRight: 'auto' }}
      >
        <Text size="200" fontWeight="semibold" textColor={contrast ? 'primary_inverse' : 'primary'}>
          <Plural value={selectedCount} one="# photo selected" other="# photos selected" />
        </Text>
        <Flex flexDirection="row" alignItems="center" gap="2x">
          <Button
            size="small"
            icon={Hide}
            loading={isSaving}
            disabled={isSaving}
            onPress={onMakePrivate}
          >
            {t`Make private`}
          </Button>
          <Button
            variant="primary"
            size="small"
            icon={Show}
            loading={isSaving}
            disabled={isSaving}
            onPress={onMakePublic}
          >
            {t`Make public`}
          </Button>
        </Flex>
      </Flex>
    </StickyGalleryToolbar>
  );
};

export default GallerySelectionBar;
